import type { DirectusErrorType } from '@/features/api/directus';

/** Types de fichier acceptés par un `Dropzone` : type MIME → extensions. */
export type AcceptedFileTypes = Record<string, string[]>;

/** Préréglages de types de fichier, combinables par décomposition (`{ ...FILE_TYPES.xls, ...FILE_TYPES.xlsx }`). */
export const FILE_TYPES = {
  csv: { 'text/csv': ['.csv'] },
  txt: { 'text/plain': ['.txt'] },
  xml: { 'application/xml': ['.xml'], 'text/xml': ['.xml'] },
  xls: { 'application/vnd.ms-excel': ['.xls'] },
  xlsx: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
} satisfies Record<string, AcceptedFileTypes>;

/** Erreur de validation d'un fichier : clé Tolgee et paramètres éventuels. */
export type FileValidationError = { key: string; params?: Record<string, string | number> };

/** Contrôle du contenu d'un fichier avant envoi ; renvoie la liste des erreurs (vide si valide). */
export type FileValidator = (file: File) => Promise<FileValidationError[]>;

/**
 * Retourne la clé de traduction du message d'erreur adapté à l'échec d'un envoi de fichier
 * via l'extension antivirus (virus détecté, analyse indisponible, fichier trop volumineux).
 */
export const getUploadErrorKey = (error: unknown, defaultKey: string): string => {
  const code = (error as Partial<DirectusErrorType> | undefined)?.errors?.[0]?.extensions?.code;

  switch (code) {
    case 'VIRUS_DETECTED':
      return 'file.upload.error.virus';
    case 'SERVICE_UNAVAILABLE':
      return 'file.upload.error.antivirus-unavailable';
    default:
      return defaultKey;
  }
};
